import { z } from 'zod';
import { isoDateStringSchema, uuidSchema } from './common';

const orderInfoRefSchema = z.object({
  id: uuidSchema,
  shopName: z.string().nullable(),
  orderNumber: z.string().nullable(),
});

export const trackingEventSchema = z.object({
  id: uuidSchema,
  occurredAt: isoDateStringSchema,
  description: z.string(),
  location: z.string().nullable(),
  status: z.string().nullable(),
});
export type TrackingEvent = z.infer<typeof trackingEventSchema>;

export const trackingSchema = z.object({
  id: uuidSchema,
  trackingNumber: z.string().min(1),
  carrier: z.string().nullable(),
  status: z.string().nullable(),
  subStatus: z.string().nullable(),
  lastStatusAt: isoDateStringSchema.nullable(),
  createdAt: isoDateStringSchema,
  orderInfo: orderInfoRefSchema.nullable(),
  events: z.array(trackingEventSchema).default([]),
});
export type Tracking = z.infer<typeof trackingSchema>;
